import { CurrencyPipe } from "@angular/common";
import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { LostOutboundClaimWidgetKpi } from "../../models/dashboard-widget-kpi.model";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-lost-outbound-claim-widget",
  standalone: true,
  imports: [MaterialModule, TranslateModule, CurrencyPipe],
  templateUrl: "./lost-outbound-claim-widget.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class LostOutboundClaimWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly kpi = input.required<LostOutboundClaimWidgetKpi>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  onViewClaims(): void {
    this.navigationSvc.navigateToClaimTypeView(
      this.listNavigation(),
      "Lost_Outbound",
    );
  }
}
